module.exports = __webpack_public_path__ + "static/media/Mintdropz_logo_black.cca86d10.png";